export default __webpack_public_path__ + "static/media/construct.57412da7.jpeg";